import { MatchUpStatusEnum } from '@clubspark-node/clubspark-tennis-types';

import { sentenceCase } from 'components/utils';

enum CustomMatchUpStatuses {
  WITHDRAWAL = 'WITHDRAWAL',
  DOUBLE_WITHDRAWAL = 'DOUBLE_WITHDRAWAL',
}

const customMatchUpStatusConstants: Record<string, CustomMatchUpStatuses> = {
  WITHDRAWAL: CustomMatchUpStatuses.WITHDRAWAL,
  DOUBLE_WITHDRAWAL: CustomMatchUpStatuses.DOUBLE_WITHDRAWAL,
};

const mappedStatuses = Object.entries<string>({ ...MatchUpStatusEnum, ...customMatchUpStatusConstants }).map(
  ([key, val]) => {
    const value = val.replace(/_/g, ' ').toLowerCase();
    const currentStatusValueSplit = value?.split(' ') || ['', ''];
    const currentStatusFirstWord = currentStatusValueSplit[0];
    if (currentStatusFirstWord) {
      currentStatusValueSplit[0] = sentenceCase(currentStatusFirstWord);
    }

    return {
      key,
      value,
      className: key,
      pretty: currentStatusValueSplit.join(' ') || '',
    };
  },
);

export const isWithdrawal = (matchUpStatusCode: string) =>
  ['WD.INJ', 'WD.ILL', 'WD.PC', 'WD.WD', 'WD.TAE'].includes(matchUpStatusCode);

export const isDoubleWithdrawal = (matchUpStatusCode: string) => ['WD.WD'].includes(matchUpStatusCode);

export const getStatus = (status, matchUpStatusCodes: string[]) => {
  const mappedStatus = isWithdrawal(matchUpStatusCodes?.[0])
    ? isDoubleWithdrawal(matchUpStatusCodes?.[0])
      ? CustomMatchUpStatuses.DOUBLE_WITHDRAWAL
      : CustomMatchUpStatuses.WITHDRAWAL
    : status;
  return mappedStatuses.find((s) => s.key === mappedStatus);
};
